// Report Status Constants
export const REPORT_STATUS = {
  PENDING: 'pending',
  UNDER_REVIEW: 'under_review',
  RESOLVED: 'resolved',
  DISMISSED: 'dismissed',
};

// Human friendly labels for statuses
export const REPORT_STATUS_LABEL = {
  [REPORT_STATUS.PENDING]: 'Pending',
  [REPORT_STATUS.UNDER_REVIEW]: 'Under Review',
  [REPORT_STATUS.RESOLVED]: 'Resolved',
  [REPORT_STATUS.DISMISSED]: 'Dismissed',
};

// Badge class mapping per status (aligns with theme colors)
export const REPORT_STATUS_BADGE = {
  [REPORT_STATUS.PENDING]: 'badge-warning',
  [REPORT_STATUS.UNDER_REVIEW]: 'badge-info',
  [REPORT_STATUS.RESOLVED]: 'badge-success',
  [REPORT_STATUS.DISMISSED]: 'badge-danger',
};

// Report Type Constants
export const REPORT_TYPE = {
  PAYMENT_ISSUE: 'payment_issue',
  SERVICE_QUALITY: 'service_quality',
  BOOKING_CONFLICT: 'booking_conflict',
  GROUND_CONDITION: 'ground_condition',
  STAFF_BEHAVIOR: 'staff_behavior',
  OTHER: 'other',
};

// Action Button Constants
export const REPORT_ACTIONS = {
  UNDER_REVIEW: 'under_review',
  RESOLVE: 'resolve',
  DISMISS: 'dismiss',
};

// Action Button Text Constants
export const ACTION_BUTTON_TEXT = {
  [REPORT_ACTIONS.UNDER_REVIEW]: 'Mark Under Review',
  [REPORT_ACTIONS.RESOLVE]: 'Resolve Report',
  [REPORT_ACTIONS.DISMISS]: 'Dismiss Report',
};

// Action Button CSS Classes
export const ACTION_BUTTON_CLASSES = {
  [REPORT_ACTIONS.UNDER_REVIEW]: 'btn-info',
  [REPORT_ACTIONS.RESOLVE]: 'btn-success',
  [REPORT_ACTIONS.DISMISS]: 'btn-danger',
};

// Action Button Icons
export const ACTION_BUTTON_ICONS = {
  [REPORT_ACTIONS.UNDER_REVIEW]: 'FaClock',
  [REPORT_ACTIONS.RESOLVE]: 'FaCheck',
  [REPORT_ACTIONS.DISMISS]: 'FaTimes',
};
